import { render, staticRenderFns } from "./LoaderV2.vue?vue&type=template&id=0002babe"
import script from "./LoaderV2.vue?vue&type=script&lang=js"
export * from "./LoaderV2.vue?vue&type=script&lang=js"
import style0 from "./LoaderV2.vue?vue&type=style&index=0&id=0002babe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports